export enum PriceChangeDirection {
    NO_CHANGE = 0,
    PRICE_DECREASED = 1,
    PRICE_INCREASED = 2
}
export enum PriceChangeDirection {
    NO_CHANGE = 0,
    PRICE_DECREASED = 1,
    PRICE_INCREASED = 2
}
